export function insertTextAtSelection(
  value: string,
  insertion: string,
  selectionStart: number | null,
  selectionEnd: number | null
): { nextValue: string; cursorPosition: number } {
  const start = selectionStart ?? value.length;
  const end = selectionEnd ?? value.length;
  const nextValue = value.slice(0, start) + insertion + value.slice(end);
  const cursorPosition = start + insertion.length;

  return { nextValue, cursorPosition };
}
